import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';

import {
    DEFAULT_CONTACTS,
    DEFAULT_CONTACT_EMAILS,
    DEFAULT_CONTACT_PHONES,
    DEFAULT_USER_INFO,
} from '../consts/initial-state';
import { DEFAULT_GEO_CITY } from '../consts/default-geo-city';

export function getInitialState(
    defaultPageModel?: any
): GeneralGlobalDataForInitialState {
    if (canUseDOM) {
        const initialState = window.__INITIAL_STATE__;
        initialState.geoCity = {
            ...initialState.geoCity,
            cityFromId:
                (initialState.geoCity && initialState.geoCity.cityFromId) ||
                DEFAULT_GEO_CITY.cityFromId,
            id:
                (initialState.geoCity && initialState.geoCity.id) ||
                DEFAULT_GEO_CITY.id,
            name:
                (initialState.geoCity && initialState.geoCity.name) ||
                DEFAULT_GEO_CITY.name,
            populationKind:
                (initialState.geoCity && initialState.geoCity.populationKind) ||
                DEFAULT_GEO_CITY.populationKind,
            regionName:
                (initialState.geoCity && initialState.geoCity.regionName) ||
                DEFAULT_GEO_CITY.regionName,
            countryId:
                (initialState.geoCity && initialState.geoCity.countryId) ||
                DEFAULT_GEO_CITY.countryId,
        };

        return initialState;
    }

    return {
        geoCity: DEFAULT_GEO_CITY,
        contacts: {
            contactEmails: DEFAULT_CONTACT_EMAILS,
            contactPhones: DEFAULT_CONTACTS,
            defaultContactPhones: DEFAULT_CONTACT_PHONES,
        },
        userInfo: DEFAULT_USER_INFO,
        pageModel: defaultPageModel || {},
    };
}
